import './_shoru_shared_library/CSS/public/Commands.css';
import './CastingBotStyle.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './home_and_login/Home';
import Login from './home_and_login/Login';
import Console from './console/Console';
import BookingPage from './booking_page/BookingPage';
import CreateAccount from './account_creation_TEMP/CreateAccount';
import AdminConsole from './admin_console/AdminConsole';
import ClashBotConsole from './clashbot_page/ClashBotConsole';
import castingBotTheme from './CastingBotTheme';
import { ThemeProvider } from '@emotion/react';
import LinkCreator from './account_creation_TEMP/LinkCreator';
import { EmailChangeComplete } from './account-settings-pages/EmailChangeComplete';

function App() {

  const theme = castingBotTheme;

  return (
    <ThemeProvider theme={theme}>
      <div>
        <BrowserRouter>
          <Routes>

            <Route exact path='/'                 element={<Home />} />
            <Route exact path='/login'            element={<Login />} />
            <Route       path='/console/*'        element={<Console />} />
            <Route       path='/invite/*'    element={<CreateAccount />} />
            <Route       path='/admin-console/*'  element={<AdminConsole appName='castingbot' />} />
            <Route       path='/clashbot/*'       element={<ClashBotConsole />} />
            <Route       path='/account/email-change-complete' element={<EmailChangeComplete />} />
            <Route       path='/*'                element={<BookingPage />} />

          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;


// <Route exact path='/login' element={<Login />} />
// <Route exact path='/*/console' element={<Console />} />
// <Route exact path='/*/admin' element={<AdminConsole />} />